import { useState } from 'react';
import './SpiritualBibleHowTo.css';

export default function SpiritualBibleHowTo() {
  const [open, setOpen] = useState(false);

  return (
    <div className="spiritual-bible-how">
      <button
        type="button"
        className="btn-primary text-sm"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        {open ? 'Cerrar guía' : 'Cómo leer la Biblia'}
      </button>
      {open ? (
        <div className="spiritual-bible-how__panel">
          <h3>Guía para empezar</h3>

          <h4>1. Preparación y versión</h4>
          <p>Escoge las herramientas adecuadas antes de empezar.</p>
          <ul>
            <li>
              <strong>Traducción clara:</strong> para comenzar, un lenguaje contemporáneo ayuda
              (NVI, NTV o Dios Habla Hoy). Si el español antiguo te frena, deja Reina-Valera 1960
              para más adelante. En esta plataforma puedes leer RVR1960 cuando te sientas listo.
            </li>
            <li>
              <strong>Formato:</strong> Biblia física de estudio, o apps como YouVersion
              además de la lectura aquí.
            </li>
            <li>
              <strong>Cuaderno:</strong> anota dudas, reflexiones y datos clave para fijar lo aprendido.
            </li>
          </ul>

          <h4>2. Un punto de partida estratégico</h4>
          <p>No hace falta ir de Génesis a Apocalipsis en la primera lectura.</p>
          <ul>
            <li>
              <strong>Empieza por los Evangelios:</strong> Marcos (corto y dinámico) o Juan
              (identidad y enseñanzas de Jesús).
            </li>
            <li>
              <strong>Sigue con cartas:</strong> Santiago, Filipenses o 1 Juan, con consejos prácticos.
            </li>
            <li>
              <strong>Sabiduría y oración:</strong> un Salmo o un capítulo de Proverbios al día,
              junto a la lectura principal.
            </li>
            <li>
              <strong>Antiguo Testamento:</strong> cuando ya te sientas cómodo en el Nuevo,
              lee Génesis y Éxodo para el origen de la historia.
            </li>
          </ul>

          <h4>3. Lectura inductiva (OIA)</h4>
          <p>Tres pasos para cada pasaje o capítulo:</p>
          <ul>
            <li>
              <strong>Observación (¿qué dice el texto?):</strong> quién habla, a quién, dónde ocurren
              los hechos y qué palabras se repiten.
            </li>
            <li>
              <strong>Interpretación (¿qué significaba entonces?):</strong> contexto histórico y cultural,
              para no sacar frases de contexto.
            </li>
            <li>
              <strong>Aplicación (¿qué significa para mi vida hoy?):</strong> un principio a vivir,
              una actitud a corregir o una enseñanza a practicar.
            </li>
          </ul>
        </div>
      ) : null}
    </div>
  );
}
